import ALL from "./ALL";
import { HEIGHTS_WITHOUT_XL } from "./heights";
import allPerformance from "./performance";
import allSeries from "./series";

// powder coating is available to performance packages except ISO3, ISO3K, ISO4, ISO4K, ISO5, ISO5K
const performance = allPerformance
  .filter(({ code }) => !["ISO3", "ISO3K", "ISO4", "ISO4K", "ISO5", "ISO5K"].includes(code))
  .map(({ code }) => code);

// all series except MVMT
const series = allSeries.filter(({ code }) => code !== "MVMT").map(({ code }) => code);

const back = ["MB", "TB", "E", "M", "T", "C", "L", "U", "S", "G", "W"]; // backs that have bars

const components = {
  seat: ALL,
  back,
  base: ALL,
  height: HEIGHTS_WITHOUT_XL,
  casters: ALL,
  control: ALL,
  footring: ALL,
  arm: ALL,
  vinylUnderwrap: ALL,
  memoryFoam: ALL,
  upholstery: ALL,
  market: ALL,
  performance,
  series,
};

export default [
  {
    code: "X",
    name: "Black / Chrome",
    description: "Black or chrome depending on performance package.",
    seat: ALL,
    back: ALL,
    base: ALL,
    height: ALL,
    casters: ALL,
    control: ALL,
    footring: ALL,
    arm: ALL,
    vinylUnderwrap: ALL,
    memoryFoam: ALL,
    upholstery: ALL,
    market: ALL,
    performance: ALL,
    series: ALL,
  },
  {
    code: "E2D8BC",
    hexColor: "#E2D8BC",
    name: "Beige/Cream",
    description:
      "Back bars and steel bases can be powder coated in a variety of eco-friendly colors including Black, Almond, Red, Gray, Blue, Green, and Purple. Custom colors can be requested through your BioFit Sales Representative.",
    ...components,
  },
  {
    code: "CA2129",
    hexColor: "#CA2129",
    name: "Red",
    description:
      "Back bars and steel bases can be powder coated in a variety of eco-friendly colors including Black, Almond, Red, Gray, Blue, Green, and Purple. Custom colors can be requested through your BioFit Sales Representative.",
    ...components,
  },
  {
    code: "949598",
    hexColor: "#949598",
    name: "Light Gray",
    description:
      "Back bars and steel bases can be powder coated in a variety of eco-friendly colors including Black, Almond, Red, Gray, Blue, Green, and Purple. Custom colors can be requested through your BioFit Sales Representative.",
    ...components,
  },
  {
    code: "164882",
    hexColor: "#164882",
    name: "Navy Blue",
    description:
      "Back bars and steel bases can be powder coated in a variety of eco-friendly colors including Black, Almond, Red, Gray, Blue, Green, and Purple. Custom colors can be requested through your BioFit Sales Representative.",
    ...components,
  },
  {
    code: "145D2F",
    hexColor: "#145D2F",
    name: "Dark Green",
    description:
      "Back bars and steel bases can be powder coated in a variety of eco-friendly colors including Black, Almond, Red, Gray, Blue, Green, and Purple. Custom colors can be requested through your BioFit Sales Representative.",
    ...components,
  },
];
